import React from 'react';
import { SandboxOrderStatus } from '@/services/api/sandbox';

// Outbound order statuses (the warehouse's own, then the shipment's once it
// leaves the hub), in the same DS state tones as the shipment badge.
const ORDER_STATUS: Record<
  SandboxOrderStatus,
  { label: string; bg: string; text: string }
> = {
  OPEN: {
    label: 'Open',
    bg: 'bg-information-lighter',
    text: 'text-information-dark',
  },
  PREPARING: {
    label: 'Preparing',
    bg: 'bg-highlighted-lighter',
    text: 'text-highlighted-dark',
  },
  READY_TO_PICKUP: {
    label: 'Ready to pick up',
    bg: 'bg-away-lighter',
    text: 'text-away-dark',
  },
  SHIPPED: { label: 'Shipped', bg: 'bg-away-lighter', text: 'text-away-dark' },
  IN_DELIVERY: {
    label: 'In Delivery',
    bg: 'bg-feature-lighter',
    text: 'text-feature-dark',
  },
  DELIVERED: {
    label: 'Delivered',
    bg: 'bg-success-lighter',
    text: 'text-success-dark',
  },
  FAILED: { label: 'Failed', bg: 'bg-error-lighter', text: 'text-error-dark' },
  CANCELLED: {
    label: 'Cancelled',
    bg: 'bg-faded-lighter',
    text: 'text-faded-dark',
  },
};

export const ORDER_STATUSES = Object.keys(ORDER_STATUS) as SandboxOrderStatus[];

export const orderStatusLabel = (status: string) =>
  ORDER_STATUS[status as SandboxOrderStatus]?.label ?? status;

export const OrderStatusBadge: React.FC<{ status: string }> = ({ status }) => {
  const c = ORDER_STATUS[status as SandboxOrderStatus] ?? {
    label: status,
    bg: 'bg-bg-weak-50',
    text: 'text-text-sub-600',
  };
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ${c.bg} ${c.text}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {c.label}
    </span>
  );
};

/** Total quantity of an order's lines, to 2 decimals. */
export const totalQty = (lines: { qty: number }[]) =>
  Math.round(lines.reduce((sum, l) => sum + Number(l.qty), 0) * 100) / 100;
